/**
 * @type {import('@chakra-ui/react').ThemeComponents}
 */
const Theme = {
  Heading: {
    baseStyle: {
      fontFamily: 'Poppins',
      fontWeight: 'semibold',
    },
    variants: {
      heading1: {
        fontSize: '5xl',
        lineHeight: 'heading1',
        wordBreak: 'break-word',
      },
      heading2: {
        fontSize: '4xl',
        lineHeight: 'heading2',
        wordBreak: 'break-word',
      },
      heading3: {
        fontSize: '3xl',
        lineHeight: 'heading3',
        paddingBottom: '10px',
        wordBreak: 'break-word',
      },
      heading4: {
        fontSize: '3xl',
        fontWeight: 'normal',
        lineHeight: 'heading3',
        wordBreak: 'break-word',
      },
      headingmodal: {
        fontSize: 'lg',
        lineHeight: 'modalheading',
        pb: 0,
      },
    },
    defaultProps: {},
  },
};

export default Theme;
